import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { defineMessage } from 'react-intl';
export const seatPaymentFailedMessage = defineMessage({
    defaultMessage: 'We couldn’t complete the payment. Check your payment method or contact your bank, then try again.',
    id: '08f35948f1',
    description: 'A payment was refused while changing Enterprise seats, inviting members, or approving a request',
});
// Recognize the typed refusal, including older servers that returned 503.
// An unknown 402 or a payment error after a committed write is not this contract.
export const isSeatPaymentFailedError = (error) => error instanceof ApiClientsError && error.detail?.error_code === 'payment_failed';
//# sourceMappingURL=seatPaymentError.js.map